/**
 * Created by lenovo2013 on 2016/7/13.
 */
var debut_param = {
    limit: 6,
    list_lastest_start: 0,
    card_lastest_start: 0
};
$(document).ready(function () {
    var firstpub_type = getUrlParam('type');
    if (!firstpub_type) {
        window.location.href = "404.html";
    }
    /*
     get slider
     */
    getDebutSlider(firstpub_type);
    /*

     */
    $('#debut_list').on('mouseenter', '.ui.card', function (event) {
        var $share = $(this).find('.share');
        $share.share();
        var $action = $(this).find('.debut-item-meta a');
        $share.css('visibility','visible');
        $action.show();
    }).on('mouseleave', '.ui.card', function (event) {
        var $share = $(this).find('.share');
        var $action = $(this).find('.debut-item-meta a');
        $share.css('visibility','hidden');
        $action.hide();
    }).on('click','.ui.card .meta a.collect',function(event){
        var firstpub_id = $(this).closest('.ui.card').data('id');

        addCollect(firstpub_id);

    });
    $('#debut_card').on('mouseenter', '.debut_li', function (event) {
        var $share = $(this).find('.share');
        $share.share();
        var $action = $(this).find('.card-meta a');
        $share.css('visibility','visible');
        $action.show();
    }).on('mouseleave', '.debut_li', function (event) {
        var $share = $(this).find('.share');
        var $action = $(this).find('.card-meta a');
        $share.css('visibility','hidden');
        $action.hide();
    }).on('click','.debut_li .card-meta span.collect',function(event){
        var firstpub_id = $(this).closest('.debut_li').data('id');

        addCollect(firstpub_id);
    });


    /*
     card or list button listener
     */

    $('#card-list .button').one('click', function (event) {
        event.stopImmediatePropagation();
        var type = $(this).data('type');

        if (type == 'card') {
            showAsCard();
            var $cards = $('#debut_card');
            var $loader = $('#card-loader');
            $cards.visibility({
                once: false,
                observeChanges: true,
                onBottomVisible: function () {
                    $loader.css('visibility', 'visible');
                    $cards.visibility('disable callbacks');

                    var promise = latestDebut(debut_param.card_lastest_start, debut_param.limit, firstpub_type);
                    promise
                        .done(function(data){
                            $cards.masonry({
                                'selector':'.debut_li'
                            });
                            var html = S['templates']['debut_card'](data);
                            var $items = $(html);
                            $('#debut_card')
                                .append($items)
                                .masonry('appended', $items,true)
                                .masonry({});
                            debut_param.card_lastest_start = debut_param.card_lastest_start + data.firstpubs.length;

                        })
                        .done(function (data) {
                            if (data.firstpubs.length == debut_param.limit) {
                                $cards.visibility('enable callbacks');
                            } else {
                                $cards.visibility('disable callbacks');
                            }
                            $loader.css('visibility', 'hidden');
                        })
                        .fail(function (data) {
                            $cards.visibility('enable callbacks');
                            $loader.css('visibility', 'hidden');
                        })
                }
            });
        } else {
            showAsList();
            var $lists = $('#debut_card');
            $lists.masonry({
                itemSelector: '.debut_li'
            });
            var $loader = $('#list-loader');
            $('#debut_list').visibility({
                once: false,
                observeChanges: true,
                onBottomVisible: function () {
                    $loader.css('visibility', 'visible');
                    $lists.visibility('disable callbacks');
                    var promise = getLastestDebut(debut_param.list_lastest_start, debut_param.limit, firstpub_type, 'list');
                    promise

                        .done(function (data) {
                            if (data.firstpubs.length == debut_param.limit) {
                                $lists.visibility('enable callbacks');
                            } else {
                                $lists.visibility('disable callbacks');
                            }
                            $loader.css('visibility', 'hidden');
                        })
                        .fail(function (data) {
                            $lists.visibility('enable callbacks');
                            $loader.css('visibility', 'hidden');

                        })
                }
            });
        }
    }).on('click', function (event) {
        var type = $(this).data('type');
        if (type == 'card') {
            showAsCard();
        } else {
            showAsList();
        }
    });
    $('#card-list .card-button').trigger('click');
    /*
     get journals
     */
    getJournals(0, 10);
});
function getJournals(start, limit) {
    var promise = journals(start, limit);
    promise.done(function (data) {
        $('#cooperative-journal').html(S['templates']['journal'](data));

    });
}
function getDebutSlider(firstpub) {
    var promise = debutSlider(firstpub);
    promise.done(function (data) {

        $('#slider').html(S['templates']['debut_slider'](data));
        $('#slider').nivoSlider({});

    });
}
function getHotDebut(start, limit, firstpub) {
    var promise = hotDebut(start, limit, firstpub);
    promise.done(function (data) {
        $('#hot_debut').append(S['templates']['debut_card'](data));
        debut_param.hot_start = debut_param.hot_start + data.length;

    });
}
function getLastestDebut(start, limit, firstpub, type) {
    var promise = latestDebut(start, limit, firstpub);
    if (type == 'card') {
        promise.done(function (data) {
            var html = S['templates']['debut_card'](data);
            var $items = $(html);
            $('#debut_card')
                .append($items)
                .masonry('appended', $items,true)

            debut_param.card_lastest_start = debut_param.card_lastest_start + data.firstpubs.length;
        });
    } else {
        promise.done(function (data) {
            var html = S['templates']['debut_item'](data);
            $('#debut_list').append(html);
            debut_param.list_lastest_start = debut_param.list_lastest_start + data.firstpubs.length;

        })

    }
    return promise;
}

function addCollect(firstpub_id) {
    if (!sessionStorage.getItem("user")) {
        $('.login-modal').modal('show');
        return;
    }
    select_debut = firstpub_id;
    var promise = collectPost(firstpub_id);
    promise.done(function (data) {
        if(data.status == 0){
            $('#warning').find('.content').text('收藏成功');
            $('#warning').modal('show');
            $('.meta span.collect i').addClass('yellow');
        }else{
            $('#warning').find('.content').text(data.message);
            $('#warning').modal('show');
        }

    });
}
/*
 fetch/post data api ,return promise for reuse
 */
function collectPost(firstpub) {
    return $.ajax({
        url: server_base + '/star/firstpub/' + firstpub,
        method: 'POST',
        //xhrFields: {withCredentials: true},
        ////crossDomain: true
    });


}
function latestDebut(start, limit, firstpub) {
    return $.ajax({
        url: server_base + '/firstpubs/summary/' + firstpub,
        method: 'GET',
        data: {
            start: start,
            limit: limit
        },
        dataType: 'json'
    });

}
function hotDebut(start, limit, firstpub) {
    return $.ajax({
        url: server_base + '/firstpubs/summary/' + firstpub,
        method: 'GET',
        data: {
            type: 'hot',
            start: start,
            limit: limit
        },
        dataType: 'json'
    });
}
function debutSlider(firstpub) {
    return $.ajax({
        url: server_base + "/showpage/firstpub",
        method: 'GET',
        data: {
            type: firstpub
        },
        dataType: "json"
    });

}
function journals(start, limit) {
    return $.ajax({
        url: server_base + '/journal/get',
        method: 'GET',
        data: {
            start: 0,
            limit: 10

        },
        dataType: 'json'
    });

}
function showAsList() {
    if (!$('.list-button').hasClass('active')) {
        $('#debut_list_container').show();
        $('#debut_card_container').hide();
        $('.list-button').addClass('active').addClass('positive');
        $('.card-button').removeClass('active').removeClass('positive');
    }

}
function showAsCard() {
    if (!$('.card-button').hasClass('active')) {
        $('#debut_card_container').show();
        $('#debut_list_container').hide();
        $('.card-button').addClass('active').addClass('positive');
        $('.list-button').removeClass('active').removeClass('positive');
    }

}